import { createAction } from '@reduxjs/toolkit';
import { LOCATION_CHANGE } from 'redux-first-history';

interface ILocation extends Location {
  state: { [key: string]: any };
}

export const locationChange =
  createAction<{ action: 'PUSH' | 'REPLACE' | 'POP'; location: ILocation }>(LOCATION_CHANGE);
